<template>
  <div class="custom-amount-form">
    <Header />
    <section class="main">
      <FixedAmount />
      <ReceiptSend />
      <PayMethods />
      <Footer />
    </section>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import FixedAmount from "@/components/FixedAmount.vue";
import ReceiptSend from "@/components/ReceiptSend.vue";
import PayMethods from "@/components/PayMethodsWithButton.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "FixedAmountForm",
  components: {
    Header,
    FixedAmount,
    ReceiptSend,
    PayMethods,
    Footer,
  },
};
</script>
